// Components==============
import ArrowButtons from 'components/UI/ArrowButtons/ArrowButtons';
import TrainingCard from 'components/UI/TrainingCard/TrainingCard';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext, useRef } from 'react';
import { AddActivityModalContext } from '../../AddActivityModal';
import './Courses.module.scss';
// =========================

const CoursesGetter = ({
  courses,
  title,
}: {
  courses: (TrainingEntity | undefined)[];
  title: string;
}) => {
  const translate = useTranslate();
  const { fn, usedCourses, handleAddSwitch, origin } = useContext(
    AddActivityModalContext
  );

  const ref = useRef<HTMLDivElement>(null);

  if (!courses.length) return <></>;

  return (
    <>
      {origin === 'growth' ? (
        <div styleName="title">
          <h3>{translate(title)}</h3>
          <ArrowButtons reference={ref} />
        </div>
      ) : (
        <h3>{translate(title)}</h3>
      )}
      <div styleName="grid" ref={ref}>
        {courses?.map(
          (course) =>
            !!course && (
              <TrainingCard
                key={course?.id}
                training={course}
                small
                withModal
                handleAdd={
                  fn === 'add'
                    ? () => handleAddSwitch('App\\Training', course)
                    : undefined
                }
                handleSwitch={
                  fn === 'switch'
                    ? () => handleAddSwitch('App\\Training', course)
                    : undefined
                }
                isUsed={usedCourses?.includes(course?.id)}
              />
            )
        )}
      </div>
    </>
  );
};

export default function Courses() {
  const { searchValue, origin } = useContext(AddActivityModalContext);

  const userId = useRedux((state) => state.authentication?.user?.id);

  const myCourses = useRedux((state) =>
    state.training?.entities.allIds
      .map((id) => state.training?.entities.byId[id])
      .filter(
        (course) => course?.owner?.id === userId || course?.subscription_id
      )
      .filter((course) => !!course?.is_published)
      .filter((c) =>
        searchValue.length
          ? c?.title.toLowerCase().includes(searchValue.toLowerCase())
          : true
      )
      .reverse()
  );

  const publicCourses = useRedux((state) =>
    state.training?.entities.allIds
      .map((id) => state.training?.entities.byId[id])
      .filter((course) => course?.visibility === 'public')
  );

  const orgCourses = useRedux((state) =>
    state.training?.entities.allIds
      .map((id) => state.training?.entities.byId[id])
      .filter((course) => course?.visibility === 'org')
  );

  return (
    <div styleName={`wrapper ${origin === 'growth' ? 'dream-modal' : ''}`}>
      <CoursesGetter
        courses={myCourses || []}
        title="course.terms.my-courses"
      />
      <CoursesGetter
        courses={publicCourses || []}
        title="course.terms.public-library"
      />
      <CoursesGetter
        courses={orgCourses || []}
        title="course.terms.organization-library"
      />
    </div>
  );
}
